import type { SxProps, Theme } from '@mui/material/styles';

import { FIGMA_REF } from '../../layout';

/**
 * Search bar — overlaps the hero bottom slightly, but lives inside
 * the heroBand so following sections are not pulled up.
 */
export const searchBarStyles: Record<string, SxProps<Theme>> = {
  wrapper: {
    position: 'relative',
    zIndex: 2,
    display: 'flex',
    justifyContent: 'center',
    width: '100%',
    paddingInline: { xs: '16px', md: '24px' },
    // Pull up over the hero; heroBand paddingBottom absorbs the hang
    marginTop: { xs: '-40px', md: `-${FIGMA_REF.search.overlap}px` },
  },
  root: (theme) => ({
    width: '100%',
    maxWidth: FIGMA_REF.search.width,
    display: 'grid',
    gridTemplateColumns: {
      xs: '1fr',
      sm: '1fr 1fr',
      md: '1fr 1fr 1fr auto',
    },
    alignItems: 'center',
    columnGap: 0,
    rowGap: theme.spacing(2),
    paddingInline: { xs: theme.spacing(2.5), md: '20px 20px 20px 12px' },
    paddingBlock: { xs: theme.spacing(2), md: '20px' },
    backgroundColor: theme.palette.common.white,
    borderRadius: `clamp(6px, 0.6vw, ${FIGMA_REF.search.radius}px)`,
    boxShadow: theme.elevations.card,
  }),
  field: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: '4px',
    minWidth: 0,
    justifyContent: 'center',
    paddingInline: { md: '20px' },
    borderRight: {
      md: `1px solid ${theme.palette.divider}`,
    },
  }),
  fieldLast: {
    borderRight: { md: 'none' },
  },
  cta: {
    justifySelf: { xs: 'stretch', md: 'center' },
    gridColumn: { xs: '1 / -1', sm: '1 / -1', md: 'auto' },
    paddingLeft: { md: '12px' },
    paddingRight: { md: '8px' },
  },
  // Outlined CTA that fills WS orange on hover.
  ctaButton: (theme) => ({
    transition: 'background-color 200ms ease, border-color 200ms ease, color 200ms ease',
    '&:hover': {
      backgroundColor: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      color: theme.palette.secondary.contrastText,
    },
  }),
};
